import { useState, useMemo, useEffect, useContext, createContext } from "react";

import { TRANSLATES } from "constants";
import { setLocalStorageItem, getLocalStorageItem } from "Utils/Common";

import de from "translate/de.json";
import en from "translate/en.json";
import es from "translate/es.json";
import fr from "translate/fr.json";
import it from "translate/it.json";
import nl from "translate/nl.json";
import pt from "translate/pt.json";

const TranslateContext = createContext();

export const TranslateProvider = ({ children }) => {
    const availableTranslates = useMemo(() => (TRANSLATES.map(e => e.key)), []);
    const initLang = useMemo(() => {
        const localStorageLang = getLocalStorageItem('lang');
        if( localStorageLang && availableTranslates.includes(localStorageLang) ){
            return localStorageLang;
        }
        return "fr";
    }, [])
    const [ lang, setLang ] = useState(initLang);

    const mapTranslations = useMemo(() => ({
        de,
        en,
        es,
        fr,
        it,
        nl,
        pt
    }), []);

    const [ translations, setTranslations ] = useState(mapTranslations?.[lang] || []);

    useEffect(() => {
        setTranslations(mapTranslations[lang]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang])

    const handleSaveLang = ( newLang ) => {
        setLang(newLang);
        setLocalStorageItem('lang', newLang);
    }

    return(
        <TranslateContext.Provider value={{ lang, setLang: handleSaveLang, translations, setTranslations }}>
            {children}
        </TranslateContext.Provider>
    );
}

export const useTranslate = ( ) => useContext(TranslateContext);
export const useTranslation = ( ) => {
    const { translations } = useTranslate();

    return (key, fallback) => {
        return translations?.[key] || fr?.[key] || fallback;
    }
}